export enum DesignAppMode {
  Editing = 'editing',
  Running = 'running',
}
